/** The live building-height controls are only shown to the named developer. */
export const canTuneBuildingHeight = (name?: string): boolean => name === "Aron" || name === "aron"
